import { Directive, OnDestroy, OnInit, inject } from '@angular/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { DeviceService } from '@app/services/device.service';

@Directive({
  selector: '[appMotionPreventedTooltip]',
  hostDirectives: [
    {
      directive: NgbTooltip,
    },
  ],
})
export class MotionPreventedTooltipDirective implements OnInit, OnDestroy {
  private tooltip = inject(NgbTooltip);
  private deviceService = inject(DeviceService);

  motionPreventedMessageSubscription = new Subscription();

  ngOnInit(): void {
    this.motionPreventedMessageSubscription = this.deviceService.currentDevice$
      .pipe(switchMap((device) => this.deviceService.selectMotionPreventedMessage(device)))
      .subscribe((message) => {
        this.tooltip.ngbTooltip = message;
      });
  }

  ngOnDestroy(): void {
    this.motionPreventedMessageSubscription.unsubscribe();
  }
}
